/** @jsx jsx */
import React, { useContext, useState } from 'react'
import { Box, jsx, Text } from 'theme-ui'
import Alert from '../Alert/Alert'
import Slider from '../Slider/Slider'
import Body from '../Typography/Body/Body'
import Timer from '../Timer/Timer'
import { ShopifyContext } from '../../Layout'
import { Space } from '..'

const DiscountBox = ({ children }) => (
  <Box
    sx={{
      padding: '5px',
      mx: '7px',
      border: 'green',
      fontWeight: 'semiBold',
    }}
  >
    {children}
  </Box>
)

export const DiscountText = props => {
  return (
    <Body
      sx={{
        color: 'white',
        fontSize: [0],
        letterSpacing: [1, null, 2],
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'center',
        lineHeight: '14px',
      }}
    >
      USE: <DiscountBox>{props.code}</DiscountBox>
      {props.dropLine && <Space height={5} sx={{ width: '100%' }} />}
      FOR{' '}
      {props.percentage
        ? `${props.percentage}% `
        : `${parseFloat(props.amount) > 0 ? props.amount : 'Dollars'} `}
      OFF SITEWIDE
    </Body>
  )
}

const PromotionalAlert = React.memo(
  ({ hide, data, discountBannerEnabled = true }) => {
    const [difference, setDifference] = useState(0)
    const { checkout } = useContext(ShopifyContext)
    const alert = data.contentfulPromotionalAlert
    const hasDiscounts =
      discountBannerEnabled && checkout && checkout.hasDiscount

    const getBGColor = () => {
      let color = {
        bg: alert.color || 'lightGray',
        text: alert.textColor || 'black',
      }
      if (alert.countdownTimer) {
        alert.countdownTimer.timelineEvents.map(i => {
          if (
            i.minutesLeft >= difference.minutes &&
            difference.hours === 0 &&
            difference.days === 0
          ) {
            color.bg = i.color
            color.text = i.textColor
          } else {
            color.bg = alert.countdownTimer.color || color.bg
            color.text = alert.countdownTimer.textColor || color.text
          }
        })
      }
      if (hasDiscounts) {
        color.bg = 'black'
        color.text = 'white'
      }

      return color
    }

    const colors = getBGColor()
    return (
      <Alert
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          top: 0,
          height: 'promotionalAlertHeight',
          width: '100%',
          bg: colors && colors.bg,
          borderRadius: 0,
          color: colors && colors.text,
          // marginTop: theme => [
          //   theme.sizes.mobileNavHeight,
          //   theme.sizes.mobileNavHeight,
          //   theme.sizes.navHeight,
          // ],
          // borderRadius: 0,
          // letterSpacing: '2px',
          zIndex: 2,
          padding: 0,
          display: hide ? 'none' : 'block',
        }}
      >
        {/* {desktop && (
        <Box
          sx={{ position: 'absolute', left: 20, top: 10 }}
          data-acsb-custom-trigger="true"
        >
          <Text
            variant="caption"
            sx={{  color: colors && colors.text, textDecoration: 'underline' }}
          >
            Enable Accessibility
          </Text>
        </Box>
      )} */}
        {!alert.countdownTimer ? (
          <Slider
            options={{
              speed: 4000,
            }}
            slides={
              hasDiscounts
                ? checkout.discounts.map(d => {
                    return (
                      <Box sx={{ textAlign: 'center' }}>
                        <DiscountText {...d} />
                      </Box>
                    )
                  })
                : alert.textSlides.map(i => (
                    <Box sx={{ textAlign: 'center' }}>
                      <Body
                        variant="buttonLabel"
                        sx={{
                          color: colors && colors.text,
                          fontWeight: 'semiBold',
                          fontSize: [0, 0, 1],
                          letterSpacing: [1, null, 2],
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {i}
                      </Body>
                    </Box>
                  ))
            }
          />
        ) : (
          <Text
            sx={{
              fontWeight: 'semiBold',
              display: 'flex',
              alignItems: 'center',
              height: '100%',
            }}
            variant="caption"
          >
            <Timer
              wrapTimer={true}
              onTimeChange={setDifference}
              countdownEndTime={alert.countdownTimer.endTime}
              endText={alert.countdownTimer.endText}
              timelineEvents={alert.countdownTimer.timelineEvents}
              countdownText={alert.countdownTimer.text}
              color={colors.text}
            />
          </Text>
        )}
      </Alert>
    )
  }
)

export default PromotionalAlert
